import { CSSProperties } from "react";
import { motion } from "framer-motion";

import styles from './index.module.scss';

type MarqueeProps = {
	text: string;
	inverted?: boolean;
	className?: string;
	style: CSSProperties;
}

export default function Marquee({text, className, inverted, style}: MarqueeProps){

	const marqueeVariants = {
		animate: {
		  	x: [inverted ? "-50%" : "0%", inverted ? "0%" : "-50%"],
		  	transition: {
				x: {
					repeat: Infinity,
					repeatType: "loop",
					duration: 25,
					ease: "linear",
				},
			},
		},
  	};

  	return (
    	<div>
			<div className={`${styles.Marquee}`}>
				<motion.div className={`${styles.Track}`} variants={marqueeVariants} whileInView="animate">
					<h1 className={`${styles.Text} ${className}`} style={style}>
						{text}{text}
					</h1>
				</motion.div>
				<div style={{visibility: 'hidden', whiteSpace: 'nowrap'}}>
					<h1 className={`${styles.Text} ${className}`} style={style}>
						{text}{text}
					</h1>
				</div>
			</div>
    	</div>
  	);
};